/* src/app/sign-up/account-information/account-information.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
* {
  font-family: Roboto;
}
.red-asterik {
  color: #d50000;
}
@media screen and (min-width: 48rem) {
  .empty-form-field {
    width: 48%;
    padding: 0em 1em;
  }
}
.contact-preference .contact-wrapper {
  margin-top: 10px;
}
.select-service-container {
  margin-top: 20px;
  display: block;
  justify-content: space-between;
  width: 94%;
}
@media screen and (min-width: 48rem) {
  .select-service-container {
    display: flex;
  }
}
.select-service-container .select-service-wrapper {
  border-radius: 5px;
  border: 1px solid #8C857E;
  padding: 20px 22px;
}
@media screen and (min-width: 48rem) {
  .select-service-container .select-service-wrapper {
    width: 48%;
  }
}
.select-service-container .select-service-wrapper label.mdc-label {
  color: #5F5753;
  font-size: 16px;
  font-weight: 500;
  margin-left: 10px;
}
.select-service-container .select-service-wrapper span {
  color: #5F5753;
  font-size: 0.875rem;
  font-weight: 400;
  display: block;
  margin-left: 43px;
}
.select-service-container .selected-service-wrapper {
  border: 2px solid #004791;
  background: #F5F9FE;
}
/*# sourceMappingURL=account-information.component.css.map */
